<template>
    <div class="view__tabs">
        <ul class="view__tabs--menu">
            <li :class="getCssClass(['payment-options', 'payment-option', 'payment-option-create'])">
                <router-link :to="{ name: 'payment-options'}">
                    {{ L.localize('Membership_Breadcrumb_PaymentOptions') }}
                </router-link>
            </li>
            <li :class="getCssClass(['taxes', 'tax', 'tax-create'])">
                <router-link :to="{ name: 'taxes'}">
                    {{ L.localize('Membership_Breadcrumb_Taxes') }}
                </router-link>
            </li>
            <li :class="getCssClass('payment-gateways')">
                <router-link :to="{ name: 'payment-gateways'}">
                    {{ L.localize('Settings_Breadcrumb_Billing') }}
                </router-link>
            </li>
        </ul>

        <dropdown
          v-if="showActions"
          v-on:delete="deleteCurrent"
          :label="actions.label"
          :links="actions.links"
          acc="actions"
          :isNotSync="true">
        </dropdown>
    </div>
</template>

<script>
import Dropdown from 'components/partials/Dropdown'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'

export default {
  name: 'Submenu',
  components: { Dropdown },
  mixins: [notifications],
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      tax: 'activeTax',
      paymentOption: 'activePaymentOption'
    }),
    showActions() {
      if ((this.tax && this.tax.id) || (this.paymentOption && this.paymentOption.id)) {
        return true
      }
      return false
    },
    actions() {
      let menu = {
        label: L.localize('Label_Actions'),
        links: []
      }
      menu.links.push({
        label: L.localize('Label_Delete'),
        bypassRouter: true,
        asFunction: true,
        url: 'delete',
        acc: 'delete'
      })
      return menu
    }
  },
  methods: {
    getCssClass(name) {
      let baseClass = name.indexOf(this.$route.name) >= 0 ? 'active' : ''
      return `view__tabs--tab ${baseClass}`
    },
    deleteCurrent() {
      if (this.tax.id) {
        this.$store.dispatch('deleteTax', this.tax.id).then(() => {
          this.$router.push({name: 'taxes'})
        })
      }
      if (this.paymentOption.id) {
        this.$store.dispatch('deletePaymentOption', this.paymentOption.id).then(() => {
          this.$router.push({name: 'payment-options'})
        })
      }
      this.showNotification({
        title: L.localize('Label_SuccessDeletion'),
        message: L.localize('Label_Success')
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// Submenu.vue?1f594dea